import React from 'react'
import ReactDOM from 'react-dom/client'
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'
import { Toaster } from 'sonner'
import App from './App.tsx'
import './index.css'
import { store } from './redux/store'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        {/* Radix modals set body pointer-events:none and dismiss on outside pointerdown; keep toasts clickable without closing them */}
        <div onPointerDown={(e) => e.stopPropagation()}>
        <Toaster
          style={{ pointerEvents: 'auto' }}
          toastOptions={{
            unstyled: true,
            classNames: {
              error: "flex-center w-full justify-start items-start text-md gap-2 bg-states-error text-white font-semibold p-4 rounded-md whitespace-pre-line text-left",
              success: "flex-center w-full justify-start text-md gap-2 bg-states-success text-white font-semibold p-4 rounded-md",
              warning: "flex-center w-full justify-start text-md gap-2 bg-states-warning text-white font-semibold p-4 rounded-md",
              info: "flex-center w-full justify-start text-md gap-2 bg-blue-400 text-white font-semibold p-4 rounded-md",
            },
          }}
      />
        </div>
        <App />
      </BrowserRouter>
    </Provider>
  </React.StrictMode>,
)

// // If you want your app to work offline and load faster, you can change
// // unregister() to register() below. Note this comes with some pitfalls.
// // Learn more about service workers: https://cra.link/PWA
// serviceWorkerRegistration.register({
//   onUpdate: (registration) => {
//     const waitingServiceWorker = registration.waiting;

//     if (waitingServiceWorker) {
//       waitingServiceWorker.addEventListener("statechange", (event) => {
//         // @ts-ignore
//         if (event.target?.state === "activated") {
//           window.location.reload();
//         }
//       });

//       waitingServiceWorker.postMessage({ type: "SKIP_WAITING" });
//     }
//   },
// });
